export default "__VITE_ASSET__BCga93Xt__"